import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import defaultConfig from './Config/config'
import ChartContainerResponsive from './ChartContainerResponsive'

require('highcharts/modules/accessibility')(Highcharts)
require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/export-data')(Highcharts)

const getDefaultTooltip = () => {
    return {
        formatter: function () {
            return `<span style="color:${this.series.color}">\u25CF</span> <b>${this.x}</b><br/><b>${this.series.name}:</b> ${this.y}`
        }
    }
}

const getOptions = (
    series,
    categories,
    title,
    customTooltip = undefined,
    yAxisTitle = undefined
) => {

    const options = {
        chart: {
            type: 'line'
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: false,
                    formatter: function () {
                        return Highcharts.numberFormat(this.y, 0, ',', '.')
                    }
                }
            }
        },
        title: {
            text: title
        },
        yAxis: {
            title: {
                text: yAxisTitle || ''
            }
        },
        xAxis: {
            categories: categories
        },
        tooltip: customTooltip || getDefaultTooltip(),
        series: series,
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 1400
                },
                chartOptions: {
                    legend: {
                        enabled: false
                    }
                }
            }]
        }
    }

    return Object.assign({}, options, defaultConfig)
};

const LineChartBasic = ({
    data,
    title = 'Line Chart',
    tooltip = null,
    yAxisTitle = null,
    ...props
}) => {

    return (
        <ChartContainerResponsive>
            <HighchartsReact
                highcharts={Highcharts}
                options={getOptions(data?.data, data?.categories, title, tooltip, yAxisTitle)}
            />
            <br />
            {props.children}
        </ChartContainerResponsive>
    )
}

export default LineChartBasic
